import PageTitle from "../../components/PagesComponents/PageTitleSection/PageTitle";

const OurVisionAndMission = () => {
  return (
    <><PageTitle pagetitle="OUR VISION & MISSION" />
    <div className=''>
      
      
    </div></>
  )
}

export default OurVisionAndMission